import { useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { isDespiaNative } from "@/lib/isDespiaNative";
import despia from "despia-native";

/**
 * Silently registers the logged-in user's ID as the OneSignal external user ID
 * via the Despia native bridge on every app load / user change.
 */
export function DespiaOneSignalSync() {
  const { user } = useAuth();

  useEffect(() => {
    if (!isDespiaNative() || !user?.id) return;

    try {
      despia(`setonesignalplayerid://?user_id=${user.id}`);
    } catch (err) {
      console.warn("[DespiaOneSignalSync] Failed to set OneSignal player ID:", err);
    }
  }, [user?.id]);

  return null;
}
